<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="8"
      cy="8"
      r="6"
      fill="#53406D"
    />
    <rect
      x="7.25"
      y="7"
      width="1.5"
      height="4.5"
      rx=".75"
      fill="#fff"
    />
    <circle
      cx="8"
      cy="5.25"
      fill="#fff"
      r=".75"
    />
  </svg>
</template>

<script>
export default {}
</script>
